export default "__VITE_ASSET__ThTVAHVL__"